import Layout from "@/layout";

export default [
  {
    path: "/areasanitariavigo",
    component: Layout,
    children: [
      {
        path: "service",
        name: "asv-service",
        component: () => import("@/modules/areasanitariavigo/views/service.vue"),
      },
      {
        path: "bookings",
        name: "asv-bookings",
        component: () => import("@/modules/areasanitariavigo/views/bookings.vue"),
      },
      {
        path: "historic",
        name: "asv-historic",
        component: () => import("@/modules/areasanitariavigo/views/historic.vue"),
      },
    ],
  },
];
